import { render, staticRenderFns } from "./forgot_password_view.vue?vue&type=template&id=ba8e753c&"
import script from "./forgot_password_view.vue?vue&type=script&lang=js&"
export * from "./forgot_password_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports